/**
 * Epic 4 (Story 4.3, S5) — gedeelde pakket-letters ("Pakket A", "Pakket B",
 * ...) voor de periodebalk en de per-tijdvak-sectiekoppen. Eigen bestand
 * (i.p.v. co-exporteren vanuit `PeriodBar.tsx`) zodat die component-only
 * blijft voor Fast Refresh.
 */
export const PACKAGE_LETTERS = ['A', 'B', 'C', 'D', 'E'];
